"use client";
import React, { useEffect, useState } from "react";

import { appendScript } from "@stadium/helpers/script-loader";
import { UpdateInnerHtml } from "@stadium/helpers/html";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";

const isWistiaVideo = ({ provider_name }) => provider_name.includes("Wistia");

const VideoPlayer = ({ videoEmbed, vimeoVideoEmbed, useHeight, useWidth, vimeoThumbnail }) => {
  const [isSafariBrowser, setIsSafariBrowser] = useState(false);
  const [innerHTML, setInnerHTML] = useState(null);
  const [showImage, setShowImage] = useState(true);

  useEffect(() => {
    appendScript(
      "https://player.vimeo.com/api/player.js",
      () => {
        try {
          const iframe = document.querySelector(".vimeo-video-iframe");
          const { Vimeo } = window;
          const player = new Vimeo.Player(iframe);

          player.on("play", () => setShowImage(false));
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error("Unable to play vimeo video!", error);
        }
      },
      undefined,
      { async: true, defer: false },
    );
  }, []);

  useEffect(() => {
    const isSafari =
      /constructor/i.test(window.HTMLElement) ||
      ((p) => p.toString() === "[object SafariRemoteNotification]")(
        !window.safari || (typeof safari !== "undefined" && window.safari.pushNotification),
      ) ||
      (navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/));
    setIsSafariBrowser(isSafari);
  }, []);

  useEffect(() => {
    setInnerHTML(
      UpdateInnerHtml(videoEmbed.html, {
        height: useHeight,
        width: useWidth,
      }),
    );
  }, [useHeight, useWidth, videoEmbed.html]);

  const renderVideo = () => (
    <>
      <iframe title="banner title" src={vimeoVideoEmbed.embed_url} className="vimeo-video-iframe" />

      {showImage && (
        <PrismicImgix
          className="header-banner-image thumb"
          src={vimeoThumbnail}
          desktop="750px"
          mobile="375px"
          tablet="400px"
          largeDisplay="1200px"
        />
      )}
    </>
  );

  return videoEmbed?.html && isWistiaVideo(videoEmbed) && isSafariBrowser ? (
    <div className="wistia_responsive_padding header-banner-vistia-video-holder">
      <div className="wistia_responsive_wrapper header-banner-vistia-video-wrapper">
        <div
          className="d-flex align-items-md-center justify-content-md-center video-holder"
          dangerouslySetInnerHTML={{ __html: innerHTML }}
        />
      </div>
    </div>
  ) : vimeoVideoEmbed?.embed_url ? (
    <div className="wistia_responsive_padding header-banner-vistia-video-holder">
      <div className="wistia_responsive_wrapper header-banner-vistia-video-wrapper">
        <div
          className="d-flex align-items-md-center justify-content-md-center video-holder"
          style={{ width: useWidth, height: useHeight }}
        >
          {renderVideo()}
        </div>
      </div>
    </div>
  ) : (
    ""
  );
};

export default VideoPlayer;
